module.exports = __webpack_public_path__ + "static/nick-7d9e1f196834aa71c6f2a4cab6d06ae6.jpg";